import img1 from "./images/illustration/fitness-img-2.jpg";

const Hour = () => {
  return (
    <>
      <section className=" container-fluid" id="demo8">
        <section className="container text-center py-4">
          <section className="row justify-content-center align-items-center py-5 ">
            <div className=" col-12 col-md-6">
              <h2 className="heading fw-bold mb-4">OUR WORKING HOURS</h2>
              <p>
                Lacinia bibendum sed dictumst <br />consectetur. Non adipiscing arcu
                vitae neque. Felis enim sit gravida sem.
              </p>
              <p>MON-FRI : 6 AM-10 PM</p>
              <p>SAT-SUN : 10 AM-11 PM</p>
              <button className="btn btn-outline-success" type="submit">
                CONTACT US
              </button>
            </div>
            <div className=" col-12 col-md-6  py-5">
              <img src={img1} alt="image not found" className="img-fluid" />
            </div>
          </section>
        </section>
      </section>
    </>
  );
};
export default Hour;
